<template>
  <v-card class="elevation-0" style="width: 360px; max-width: 100%;">
    <v-card-title class="py-3 px-4 d-flex justify-space-between align-center border-bottom">
      <span class="subtitle-1 font-weight-bold">Thông báo</span>
      <v-btn
        v-if="items.length > 0"
        small
        text
        color="primary"
        class="text-none px-2"
        @click="markAllAsRead"
      >
        Đọc tất cả
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    
    <v-card-text class="pa-0" style="max-height: 400px; overflow-y: auto;">
      <v-list two-line class="pa-0">
        <template v-if="items.length === 0">
          <v-list-item class="py-4 text-center">
            <v-list-item-content>
              <v-icon color="grey lighten-1" size="36" class="mb-2">notifications_off</v-icon>
              <v-list-item-subtitle class="grey--text text--darken-1">Bạn không có thông báo nào mới!</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-else>
          <v-list-item
            v-for="item in items"
            :key="item.ID"
            @click="handleClick(item)"
            :class="{'unread-item': item.Status === 0}"
            class="notification-item py-1"
          >
            <v-list-item-avatar class="my-auto">
              <v-avatar :color="getSeverityColor(item.Severity)" size="36" class="white--text">
                <v-icon size="20" class="white--text">{{ getSeverityIcon(item.Severity) }}</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="body-2 font-weight-bold" :class="item.Status === 0 ? 'black--text' : 'grey--text text--darken-2'">
                {{ item.Title }}
              </v-list-item-title>
              <v-list-item-subtitle class="caption mt-1 text-wrap" :class="item.Status === 0 ? 'grey--text text--darken-4' : 'grey--text'">
                {{ item.Message }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="caption mt-1 grey--text" style="font-size: 10px !important;">
                {{ item.CreatedDate | display_date }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="item.Status === 0" class="my-auto">
              <span class="unread-dot"></span>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
    </v-card-text>
    
    <v-divider></v-divider>
    <v-card-actions class="pa-0">
      <v-btn block text color="primary" class="ma-0 py-3 text-none" @click="displayAll">
        Xem tất cả thông báo
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { display_date } from "@/commons/formater";

export default {
  name: "NotificationList",
  filters: { display_date },
  computed: {
    items() {
      // notification/top5 should be an array of notifications
      return this.$store.state.notification.top5 || [];
    }
  },
  methods: {
    getSeverityIcon(severity) {
      switch (severity) {
        case 'error': return 'error';
        case 'warning': return 'warning';
        case 'info':
        default:
          return 'info';
      }
    },
    getSeverityColor(severity) {
      switch (severity) {
        case 'error': return 'red lighten-1';
        case 'warning': return 'orange lighten-1';
        case 'info':
        default:
          return 'blue lighten-1';
      }
    },
    handleClick(item) {
      this.$store.dispatch("notification/markRead", item.ID).then(() => {
        let params = {};
        if (item.ActionRouteParams) {
          try {
            params = typeof item.ActionRouteParams === 'string' 
              ? JSON.parse(item.ActionRouteParams) 
              : item.ActionRouteParams;
          } catch (e) {
            console.error("Failed to parse ActionRouteParams", e);
          }
        }
        
        // Emit event to close the containing menu
        this.$emit("close-menu");
        
        if (item.ActionRouteName) {
          this.$router.push({ name: item.ActionRouteName, params: params }).catch(() => {});
        }
      });
    },
    markAllAsRead() {
      this.$store.dispatch("notification/markAllRead");
    },
    displayAll() {
      this.$emit("close-menu");
      this.$router.push({ name: "NotificationList" }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.notification-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  transition: background-color 0.2s ease;
  cursor: pointer;
}
.notification-item:hover {
  background-color: rgba(0, 0, 0, 0.02);
}
.unread-item {
  background-color: rgba(25, 118, 210, 0.04);
}
.unread-item:hover {
  background-color: rgba(25, 118, 210, 0.08);
}
.unread-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #1976D2;
  display: inline-block;
}
.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.text-wrap {
  white-space: normal;
}
</style>
